module.exports = {
  noResult: '暂无匹配结果',
  selected: '已选',
  unseleted: '未选择',
  productManager: '商品管理',
  productInfo: '商品信息',
  duplicateSpecificationNameErrorTips: '规格名称重复',
  selectedProduct: '已选商品({args1})',
  managerMenu: '管理菜单',
  productMenu: '商品菜单',
  menu: '菜单',
  startTimeNotMoreThanEndTime: '开始时间不得大于结束时间!',
  pleaseCheckProduct: '请先勾选商品',
  dragSort: '可拖动排序',
  addClassification: '添加分类',
  addProduct: '新增商品',
  editProduct: '编辑商品',
  sort: '排序',
  productSort: '商品排序',
  menuName: '菜单名称',
  menuId: '菜单ID',
  classificationShow: '展示设置',
  productNum: '商品数量',
  checkMenuTips: '请至少勾选一个菜单项!',
  confirmBatchDelMenu: '是否确认删除{args1}个菜单',
  noMenuId: '系统自动生成无需填写',
  every: '每',
  everyDay: '每天',
  pleaseInputProductCategory: '请输入商品类目',
  classfications: '分类',
  classfication: '分类列表',
  all: '全部',
  addOrEdit: '新增/编辑商品',
  productList: '商品列表',
  productName: '商品名称',
  productStatus: '库存状态',
  salesStatus: '销售状态',
  activityStatus: '活动状态',
  soldOut: '无货',
  inStock: '有货',
  productID: '商品ID',
  productPrice: '规格价格',
  lunchBoxFee: '餐盒费',
  stock: '库存',
  salesMount: '销售数量',
  activityDiscount: '活动优惠',
  onShelf: '上架',
  unShelf: '下架',
  discount: '减价',
  productImage: '商品图片',
  noLink: '未关联',
  toZero: '沽清',
  salesRaking: '销量排序',
  productDesc: '商品描述',
  newProduct: '新品',
  deleteProduct: '是否确认删除{args1}件商品？',
  zeroProduct: '沽清,是否确认？',
  linkStatus: '活动排期',
  productSpecification: '商品规格',
  productAttr: '商品属性',
  currentInventory: '当前库存',
  full: '满',
  autoFull: '自动置满',
  dailyAutoFull: '库存每日4:00自动置满',
  maxValue: '库存最大值',
  addSpecification: '添加规格',
  specification: '规格',
  productsPrice: '商品价格',
  barCode: '商品条形码',
  addAttributes: '添加选项',
  attributesName: '属性名称',
  attributesConfig: '属性设置',
  option: '选项',
  markUp: '加价',
  RequiredItem: '必选，需要选',
  item: '项',
  optionalItem: '非必选，最多选',
  productDiscount: '商品优惠',
  hotProduct: '爆品活动',
  explosiveProductPrice: '爆品售价',
  noTranslate: '未翻译',
  setLunchBox: '是否设置餐盒费',
  lunchBoxContent: '设置打包费将会影响用户下单,是否确认',
  noSelectCategory: '未设置商品菜单，是否提交?',
  importType: '导入类型',
  onlyInsertData: '仅新增数据',
  onlyUpdateData: '仅更新数据',
  reSelect: '重新选择',
  selectFile: '选择数据',
  illustrate: '说明',
  illustrate1: '1.导入文件只支持.xlsx格式；',
  illustrate2: '2.将需要上传的数据放在第一个sheet中；',
  illustrate3: '3.如需通过导入更新数据，请先将列表数据导出（含id），基于导出的文件修改完成后再导入；',
  illustrate4: '4.单次导入建议不超过1000个商品，如果商品过多，请拆分多个文件分批导入；',
  illustrate5: '5.导入更新操作无法撤回，请谨慎操作；',
  downloadImportTemplate: '下载导入模版',
  startImport: '开始导入',
  productStock: '商品库存',
  specificationName: '规格名称',
  dataImport: '数据导入',
  loadingImportTips: "正在导入{len}条数据",
  dataValid: '数据校验',
  loadingValid: '正在校验',
  dataImportSuccess: '数据导入成功',
  importException: '导入超时或者数据异常',
  dataIsEmpty: "数据为空",
  dataImportFailed: "数据导入失败",
  importReminder: "导入提醒",
  bigSize: '超过最大导入行1000',
  fileIsEmpty: '文件为空',
  storeDoesNotExist: "门店不存在",
  unknownMistake: "未知错误",
  dataCanBeImported: "可导入数据",
  unableToImportData: "无法导入数据",
  downloadWrongData: "下载错误数据",
  importTemplateError: '导入模版有误',
  importOnlyCorrectData: "仅导入正确数据",
  failedToGetStoreInformation: '获取门店信息失败',
  importTimeout: "导入校验超时，请减少数据或分批导入",
  productSelectLimit: "选择上限1000条",
  productNameMust: "商品名称至少填写一种语言",
  productCategory: "商品类目",
  selectProductCategory: "选择商品类目",
  productCategoryList: "商品类目列表",
  selectedCategory: "请勾选一个类目！",
  pendingDataNotExist: "待更新的数据已全部不存在",
  itemCharge: '件商品收取',
  enableMultiCharge: '开启多件收费',
  dynamicCal: '开启后，商品餐盒费将按照商品数量变化进行计算。',
  example: '举例',
  per3Item: '每3件商品收取$1',
  userBuyChargedOne$: '用户购买1-3件商品时,收取$1;',
  userBuyChargedTwo$: '用户购买4-6件商品时,收取$2，',
  andSoOn: '以此类推',
  packageFee: '包装费',
  importActualNumLarge1000: '导入实际数量大于1000',
  dataChanges: '数据发生变更!',
  existJoinedActivityProduct: '存在已参与活动的商品,无法删除!',
  existJoinedActivityProductSingle: '该商品已参与活动，请退出活动后重试！',
  updateType: '更新类型',
  overbigsize: '导出数据超出上限，仅导出前2000条数据',
  productTopicActivity: '商品优惠主题活动',
  storeRecommendation: '店长推荐',
  storeRecommendationOverTips: '已满5个店长推荐产品，请清理后再设置',
  sortTips: '选择菜单后可进行排序',
  uploadImgTip:"正在上传{num}张图片",
  productImg:"商品图片",
  matchMethod:"匹配方式:",
  selectMatchMethod:"请选择匹配方式",
  pleaseUploadPic:"请上传图片",
  uploadFailTip:"上传失败",
  downloadFailData:"下载失败数据",
  uploadComplete:"上传完成",
  success:"成功",
  fail:"失败",
  batchUploadPictures:"批量上传图片",
  MenuPreview: "菜单预览",
  MenuType:"菜单类型",
  upload: "上传",
  Prodcutdiscount: '商品优惠',
  NormalMenu: '普通菜单',
  BestsellMenu: '爆品菜单',
  RecommendMenu: '推荐菜单',
  SOPMenu: '商品SOP',

}
